/**
 * @see https://github.com/dw-zenid/zenid/blob/24ea894d20e52fd72bce10a7b273fea8dd926e95/admin-api/src/util/index.ts#L1
 */
function parseEnv(env: '1' | '0' | 'true' | 'false' | string | undefined): string | boolean {
  if (!env) {
    return false;
  }
  try {
    return Boolean(JSON.parse(env));
  } catch {
    return env;
  }
}

export const MOCK_MODE = import.meta.env.DEV && import.meta.env.MODE === 'mock';

/**
 * パスキーの項目を非表示にするフラグ
 */
export const HIDE_PASSKEY_LIST_ITEM = true;

/**
 * 大学開学フラグ
 * 開学までは、false
 * 開学後は、true
 */
// TODO: 大学開学時にフラグは削除する
export const IS_UNIVERSITY_OPENING = parseEnv(import.meta.env.VITE_UNIVERSITY_OPENING);

export const disallowDomains = import.meta.env.VITE_DISALLOW_DOMAINS;

export const allowDomains = import.meta.env.VITE_ALLOW_DOMAINS;
